import rioplexLogo from "@/assets/rioplex-logo.svg";
import Comet from "./Comet";

// LCP-critical assets loaded from public folder for preload discoverability
const texasMap = "/texas-map.svg";
const heroBgVideo = "/hero-bg.webm";

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center pt-[150px] lg:pt-20">
      {/* Hero background as video for smooth animation */}
      <video
        src={heroBgVideo}
        autoPlay
        loop
        muted
        playsInline
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover -z-10"
      />
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 md:gap-12">
          <div className="relative flex flex-col items-center gap-4 w-full md:w-1/2 md:max-w-[50%]">
            <div className="absolute top-0 -translate-y-full -mt-16 left-8 ml-8">
              <Comet scale={0.7} mobileScale={0.49} duration={0.5} delay={0.5} />
            </div>
            <div className="absolute top-0 -translate-y-3/4 left-0">
              <Comet scale={1.4} mobileScale={0.98} duration={0.9} delay={0.7} />
            </div>
            <img src={rioplexLogo} alt="RioPlex" width={600} height={200} className="w-full h-auto object-contain" />
          </div>
          {/* eslint-disable-next-line react/no-unknown-property */}
          <img
            src={texasMap}
            alt="Texas Map"
            width={500}
            height={600}
            loading="eager"
            decoding="async"
            // @ts-expect-error - fetchpriority is valid HTML but React types don't include it
            fetchpriority="high"
            className="w-full md:w-1/2 md:max-w-[50%] lg:w-[40%] lg:max-w-[40%] h-auto object-contain"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
